import React from "react";
import "./SettingsPage.css";

export default function SettingsPage() {
  return <div className="settings-dash-page">SettingsPage</div>;
}
